import { useCallback, useEffect, useState } from 'react';
import { NO_FILTER, SectorFilter, parseStoredFilter } from '../analytics/sectorFilter';

const STORAGE_KEY = 'karting-timing-sector-filter';

function read(): SectorFilter {
  try {
    return parseStoredFilter(localStorage.getItem(STORAGE_KEY));
  } catch {
    return NO_FILTER;
  }
}

/**
 * The teams the sector comparison is narrowed to, remembered in this browser so it
 * survives a reload part-way through a long race. Live and replay share it.
 */
export function useSectorFilter(): {
  filter: SectorFilter;
  setFilter: (next: SectorFilter) => void;
  clear: () => void;
} {
  const [filter, setFilter] = useState<SectorFilter>(read);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filter));
    } catch {
      // Private mode or a full quota: the filter just will not be remembered.
    }
  }, [filter]);

  const clear = useCallback(() => setFilter(NO_FILTER), []);
  return { filter, setFilter, clear };
}
